"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeBaseModelT = exports.KBTagT = exports.KBRevisionT = exports.KBSnippetT = void 0;
const tBox = __importStar(require("@sinclair/typebox"));
const meta_types_1 = require("./meta-types");
exports.KBSnippetT = tBox.Object({
    ID: tBox.Number(),
    CurrentRevision: tBox.Number(),
    Archived: meta_types_1.tBoolT,
    Tags: tBox.Array(tBox.Number()),
    Created: tBox.String(),
    Updated: tBox.String(),
    Revisions: tBox.Number(),
});
exports.KBRevisionT = tBox.Object({
    ID: tBox.Number(),
    Snippet: tBox.Number(),
    Title: tBox.String(),
    Markdown: (0, meta_types_1.MaybeT)(tBox.String()),
    EditedBy: tBox.Number(),
    Created: tBox.String(),
});
exports.KBTagT = tBox.Object({
    ID: tBox.Number(),
    Count: tBox.Number(),
    Name: tBox.String(),
});
exports.KnowledgeBaseModelT = tBox.Object({
    snippets: (0, meta_types_1.ModelTypeT)(exports.KBSnippetT),
    revisions: (0, meta_types_1.ModelTypeT)(exports.KBRevisionT),
    tags: (0, meta_types_1.ModelTypeT)(exports.KBTagT),
});
//# sourceMappingURL=types-kb.js.map